import { CustomButton, SearchBar, SwitchButton } from "components/form";
import React, { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { CustomModal, PopupModal } from "components/modals/ModalBox";
import { dateFormat, dateFormatWithTime } from "utils/dateFormat";
import { IoMdArrowRoundBack } from "react-icons/io";
import Pagination from "react-js-pagination";
import useFullPageLoader from "common/UseFullPageLoader";
import useButtonLoader from "common/UseButtonLoader";
import { FaRegEdit, FaRegTrashAlt, FaTimes } from "react-icons/fa";
import useDebounce from "common/UseDebounce";
import { toastMessage } from "utils/toastMessage";
import NotFound from "common/NotFound";
import { SlRefresh } from "react-icons/sl";
import { Input } from "common/InputForm";
import { toast } from "sonner";
import {
  addSubCategoryApi,
  removeSubCategory,
  SubCategoryListApi,
  updateSubCategoryApi,
  updateSubCategoryStatus,
} from "services/category";
const ProductSubCategoryManagement = () => {
  const [deleteModal, setDeleteModal] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [search, setSearch] = useState("");
  const debouncedValue = useDebounce(search, 300);
  const [fieldName, setFieldName] = useState("");
  const [direaction, setDirection] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedCategory, setSelectedCategory] = useState({});
  const [statusModal, setStatusModal] = useState(false);
  const [total, setTotal] = useState(null);
  const [buttonLoader, setButtonLoader] = useButtonLoader("Yes");
  const [buttonLoaders, setButtonLoaders] = useButtonLoader("Yes");
  const activePage = +searchParams.get("page") || 1;
  const limit = +searchParams.get("limit") || 10;
  const statusValue = searchParams.get("status") || "";
  const [loader, onShow, onHide] = useFullPageLoader();
  const [title, setTitle] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const [categoryModel, setCategoryModel] = useState(false);
  const [buttonLoaderUpdate, setButtonLoaderUpdate] = useButtonLoader("Update");
  const [errors, setErrors] = useState({});
  const { id } = useParams();
  const [titles, setTitles] = useState("");
  const [buttonLoaderFile, setButtonLoaderFile] = useButtonLoader("Export");

  const addTitleField = () => {
    setTitles([...titles, ""]);
  };
  const removeTitleField = (index) => {
    const updatedTitles = [...titles];
    updatedTitles.splice(index, 1);
    setTitles(updatedTitles);
  };
  // sort
  const toggleSortOrder = () => {
    setDirection(direaction === "ASC" ? "DESC" : "ASC");
  };
  const handleSort = (field) => {
    if (field === fieldName) {
      toggleSortOrder();
    } else {
      setFieldName(field);
      setDirection("ASC");
    }
  };
  // delete handler
  const deleteHandler = (id) => {
    setSelectedCategory({ subCategoryId: id, action: "delete" });
    setDeleteModal(true);
  };
  // change delete handler
  const changeDeleteHandler = async () => {
    try {
      setButtonLoaders(true);
      const res = await removeSubCategory(selectedCategory.subCategoryId);
      if (res.data.status === 200) {
        toastMessage(res.data.message, "success", "delete");
        searchParams.delete("page");
        subCategoryListHandler();
        setDeleteModal(false);
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoaders(false);
    }
  };
  // change student status
  const statusHandler = (categoryId, status) => {
    setSelectedCategory({
      ...selectedCategory,
      id: categoryId,
      status: status === "true" ? "false" : "true",
    });
    setStatusModal(true);
  };
  /**************Change Status Handler*********************/
  const changeStatusHandler = async () => {
    try {
      setButtonLoader(true);
      const res = await updateSubCategoryStatus(selectedCategory);
      if (res.data.status === 200) {
        toastMessage(res.data.message, "success", "changeStatus");
        setStatusModal(false);
        subCategoryListHandler();
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoader(false);
    }
  };
  /*************Reset Filter Handler*********************/
  const resetFilterHandler = () => {
    searchParams.delete("status");
    setSearch("");
    searchParams.delete("page");
    setSearchParams(searchParams);
  };
  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParams.set("page", event);
    setSearchParams(searchParams);
  };
  /**************Modal CLose*********************/
  const closeModal = () => {
    setStatusModal(false);
    setSelectedCategory({});
  };
  //-----------status-------------
  const handleStatus = (event) => {
    const value = event.target.value;
    searchParams.set("status", value);
    searchParams.set("page", 1);
    setSearchParams(searchParams);
  };
  // subCategory list handler
  const subCategoryListHandler = async (
    page = activePage,
    limit = "10",
    search = debouncedValue,
    sortField = fieldName || "createdAt",
    sortDirection = direaction,
    category = id,
    status = statusValue
  ) => {
    try {
      onShow();
      const res = await SubCategoryListApi({
        page,
        search,
        limit,
        sortField,
        sortDirection,
        category,
        status,
      });
      if (res?.data?.status === 200) {
        setTotal(res.data.data.total);
        setCategoryList(res.data?.data?.subCategories);
        onHide();
      } else {
        toastMessage(res?.data?.message, "error", "subCategories");
      }
    } catch (e) {
      onHide();
      toast.error(e.message);
    }
  };
  // add and edit handler
  const addOrEditHandler = (id, title, action) => {
    setCategoryModel(true);
    if (action === "edit") {
      setSelectedId(id);
      setTitle(title);
    } else {
      setSelectedId(null);
    }
  };
  // validation
  const validation = () => {
    let status = true;
    const error = {};

    if (!title) {
      // If we are editing and title is empty
      error["title"] = "Please enter title";
      status = false;
    }

    setErrors(error);
    return status;
  };
  // update category
  const updateAndAddCategory = async (e) => {
    e.preventDefault();
    if (validation()) {
      setButtonLoaderUpdate(true);
      if (selectedId) {
        console.log(selectedId, "selected");
        try {
          const formData = new FormData();
          formData.append("id", selectedId);
          formData.append("name", title);

          const res = await updateSubCategoryApi(formData);
          if (res?.data?.status === 200) {
            toastMessage(res?.data?.message, "success", "updateGroup");
            setCategoryModel(false);
            setTitle("");
            setTitles([""]);
            setErrors("");
            subCategoryListHandler();
          }
        } catch (e) {
          console.log("Error:", e.message);
        } finally {
          setButtonLoaderUpdate(false);
        }
      } else {
        try {
          console.log(selectedId, "selected");
          const formData = new FormData();
          // Append the subCategories array as a JSON
          formData.append("category", id);
          formData.append("name", title);
          const res = await addSubCategoryApi(formData);
          if (res?.data?.status === 200) {
            toastMessage(res?.data?.message, "success", "addCategory");
            setCategoryModel(false);
            setTitle("");
            setTitles([""]);
            setErrors("");
            subCategoryListHandler();
          }
        } catch (e) {
          console.log("Error:", e.message);
        } finally {
          setButtonLoaderUpdate(false);
        }
      }
    }
  };
  useEffect(() => {
    if (Number(activePage) === 1) {
      searchParams.delete("page");
      setSearchParams(searchParams);
    }
    subCategoryListHandler();
  }, [
    searchParams,
    debouncedValue,
    fieldName,
    direaction,
    activePage,
    statusValue,
  ]);
  useEffect(() => {
    if (search) {
      searchParams.delete("page");
    }
  }, []);

  return (
    <>
      <div className="student_management">
      <div className="card top_card">
        <div className="dashboard_title has_child">
          <h3>
            <Link to={"/product-category-management"}>
              <IoMdArrowRoundBack />
            </Link>{" "}
            Sub Categories
          </h3>
          <CustomButton
            type="button"
            className="button mx-2"
            onClick={() => addOrEditHandler("", "", "add")}
          >
            Add Sub-Category
          </CustomButton>
        </div>

        <div className="button_section_wrap">
          <div className="search_wrapper">
            <SearchBar
              placeholder={"Search..."}
              onChange={(e) =>{ setSearch(e.target.value)
                searchParams.delete("page");
                setSearchParams(searchParams);

                }
              }              value={search}
            />
            <div className="d-flex align-items-center">
              <select
                className="input form-control"
                value={statusValue}
                onChange={handleStatus}
              >
                <option value={""}>Select Status</option>
                <option value="true">Active</option>
                <option value="false">In Active</option>
              </select>

              <CustomButton onClick={resetFilterHandler}>Reset</CustomButton>
            </div>
          </div>
        </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="table_wrap ">
              <table className="table custom_table">
                <thead>
                  <tr>
                    <th className="nowrap">S.No. </th>
                    <th className="nowrap cursor-pointer" onClick={() => handleSort("name")}>
                      Sub Category
                      <span className="shorting">
                      {fieldName === "name"
                        ? direaction === "ASC"
                          ? "↑"
                          : "↓"
                        : "↓"}
                        </span>
                    </th>

                    <th
                      className="nowrap"
                      onClick={() => handleSort("createdAt")}
                    >
                      Created At{" "}
                      {fieldName === "createdAt"
                        ? direaction === "ASC"
                          ? "↑"
                          : "↓"
                        : "↓"}
                    </th>
                    <th>Status</th>

                    <th className="nowrap text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loader}
                  {categoryList && categoryList.length > 0 ? (
                    categoryList?.map((data, index) => {
                      return (
                        <tr key={++index}>
                          <td className="nowrap">{index + 1}</td>
                          <td className="nowrap">{data?.name}</td>
                          <td className="nowrap">
                            {" "}
                            {dateFormat(data?.createdAt)}
                          </td>
                          <td className="text-center">
                            {" "}
                              <Link
                                to=""
                                className="icon_button"
                                onClick={(e) => {
                                  e.preventDefault();
                                  statusHandler(
                                    data._id,
                                    data?.status.toString()
                                  );
                                }}
                              >
                                <SwitchButton
                                  status={data?.status.toString()}
                                />
                              </Link>
                          </td>
                          <td>
                            {" "}

                            <div className="icon_wrap">
                            <Link
                                onClick={() =>
                                  addOrEditHandler(
                                    data?._id,
                                    data?.name,
                                    "edit"
                                  )
                                }
                                className="icon_button"
                              >
                                <FaRegEdit />
                              </Link>
                              <Link
                                to=""
                                className="icon_button"
                                onClick={(e) => {
                                  e.preventDefault();
                                  deleteHandler(data?._id);
                                }}
                              >
                                <FaRegTrashAlt />
                              </Link>
                           
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <NotFound
                      cols={7}
                      msg={"SubCategory data not found"}
                      onHide={onHide}
                    />
                  )}
                </tbody>
              </table>
            </div>
            {total > limit && (
              <div className="pagination-wrapper">
                <div className="Pagination">
                  <Pagination
                    activePage={activePage}
                    previousLabel={"previous"}
                    nextLabel={"next"}
                    itemsCountPerPage={limit}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    hideDisabled={true}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Delete Student Modal */}
      <PopupModal
        show={deleteModal}
        handleClose={() => {
          setSelectedCategory({});
          setDeleteModal(false);
        }}
        content="Are you sure you want to delete this Sub Category?"
        title="Delete Sub Category"
        onShow={changeDeleteHandler}
        buttonLoader={buttonLoaders}
      />
      <PopupModal
        show={statusModal}
        handleClose={closeModal}
        content="Are you sure you want to change status of this Sub Category?"
        title="Change Status"
        onShow={changeStatusHandler}
        buttonLoader={buttonLoader}
      />
      {/*add and edit subCategory model*/}
      <CustomModal
        className={"edit_model"}
        show={categoryModel}
        handleClose={() => {
          setCategoryModel(false);
          setTitle("");
          setErrors("");
          setTitles([""]);
          setSelectedId(null);
        }}
      >
        <h3>
          {selectedId ? "Edit Sub Category" : "Add Sub-Category"}
        </h3>
        <div className="edit_model">
          {selectedId ? (
            <>
              <div className="form_field">
                <Input
                  className={"form-control input"}
                  type={"text"}
                  label="Title"
                  value={title || ""}
                  onChange={(e) => setTitle(e.target.value)}
                  placeholder={"Enter title"}
                  name={"title"}
                  error={errors?.title}
                />
              </div>
            </>
          ) : (
            <>
              <div className="form_field">
                <label className="label">Title </label>
                <Input
                  className={"form-control input"}
                  type={"text"}
                  value={title || ""}
                  onChange={(e) => setTitle(e.target.value)}
                  placeholder={`Enter title `}
                  name={`title`}
                  error={errors?.title}
                />
              </div>
            </>
          )}
        </div>

        <div className="button_wrap">
          <button
            type="button"
            className="button light"
            onClick={() => {
              setCategoryModel(false);
              setTitle("");
              setErrors("");
              setTitles([""]);
              setSelectedId(null);
            }}
          >
            Cancel
          </button>

          <button
            type="button"
            ref={buttonLoaderUpdate}
            onClick={updateAndAddCategory}
            className="button"
          >
            Submit
          </button>
        </div>
      </CustomModal>
    </>
  );
};

export default ProductSubCategoryManagement;
